module.exports = __webpack_public_path__ + "static/media/destination-marker.98b175e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/destination-marker.svg
// module id = 241
// module chunks = 0